<template>
  <div>
    <v-card>
      <v-card-title
        :style="{ 'background-color': getThemeColor, color: 'white' }"
        class="headline lighten-2"
        >Add Payment</v-card-title
      >
      <v-text-field
        v-if="sid"
        class="mx-6"
        readonly
        label="Student ID"
        :rules="rules"
        :value="sid"
      ></v-text-field>
      <v-list-item three-line v-else>
        <v-autocomplete
          prepend-inner-icon="search"
          v-model="selectedStudentSid"
          :items="students"
          solo-inverted
          flat
          hide-details
          label="Search Student"
        ></v-autocomplete>
      </v-list-item>
      <v-text-field
        class="mx-6"
        :label="'Amount in ' + getCurrency"
        :rules="rules"
        v-model="amount"
      ></v-text-field>
      <v-select
        class="mx-6"
        v-model="descriptionID"
        item-text="name"
        item-value="id"
        :items="categories"
        label="Description"
      ></v-select>

      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="paymentDate"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            class="mx-6"
            :rules="rules"
            v-model="paymentDate"
            label="Date"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="paymentDate" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(paymentDate)"
            >OK</v-btn
          >
        </v-date-picker>
      </v-menu>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" dark @click="savePayment()">Pay Now</v-btn>
        <v-btn color="primary" dark @click="cancelPayment()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
    <vLoader></vLoader>
  </div>
</template>

<script>
import studentsJs from "@/plugins/students";
import vLoader from "@/components/Legos/vLoader.vue";

export default {
  props: {
    sid: {
      default: null,
    },
    students: {
      default: () => [],
    },
  },
  watch: {
    sid(newVal) {
      this.selectedStudentSid = newVal;
    },
  },
  components: { vLoader },
  computed: {
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  async mounted() {
    this.$store.commit("setLoader", true);
    this.selectedStudentSid = this.sid;
    await this.getIncomeCategories();
    this.$store.commit("setLoader", false);
  },
  data: () => ({
    selectedStudentSid: null,
    descriptionID: null,
    categories: [],
    menu: null,
    amount: 0,
    paymentDate: new Date().toISOString().substring(0, 10),
    rules: [(value) => !!value || "Required!!"],
  }),
  methods: {
    async getIncomeCategories() {
      this.categories = await studentsJs.getAllIncomesCategories();
    },
    async savePayment() {
      this.$store.commit("setLoader", true);
      if (this.selectedStudentSid != null) {
        const payments = await studentsJs.savePayment(
          this.selectedStudentSid,
          this.paymentDate,
          this.amount,
          this.descriptionID
        );

        this.$toast.success("Payment Successfully Recorded!", {
          duration: 3000,
        });
        this.$emit("payment-recorded", payments);
      } else {
        alert("Make Sure A Student is Selected!");
      }
      this.$store.commit("setLoader", false);
    },
    cancelPayment() {
      this.description = null;
      this.amount = 0;
      this.paymentDate = new Date().toISOString().substring(0, 10);
      this.$emit("payment-cancelled");
    },
  },
};
</script>
